import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class ArticleStatusEffects {
  constructor(private actions$: Actions) {}
}
